import React from 'react';
import ImgOrnament from '../../../assets/ornament.png';

interface IAboutSectionProps {
  scrollRef: React.LegacyRef<HTMLDivElement> | undefined;
  settings: any;
}

const AboutSection: React.FunctionComponent<IAboutSectionProps> = ({
  scrollRef,
  settings,
}) => (
  <div ref={scrollRef} className="about-section">
    <div
      className="about-section-title"
      dangerouslySetInnerHTML={{
        __html: settings?.aboutSectionTitle,
      }}
    />
    <div className="about-panel">
      <img className="top-img" src={ImgOrnament} alt="" />
      <img className="bottom-img" src={ImgOrnament} alt="" />
      <p
        className="content"
        dangerouslySetInnerHTML={{
          __html: settings?.aboutSection1,
        }}
      />
      <p
        className="content"
        dangerouslySetInnerHTML={{
          __html: settings?.aboutSection2,
        }}
      />
      <div className="content-title">{settings?.aboutHKIRC}</div>
      <p className="content">{settings?.aboutHKIRCDetail}</p>
    </div>
  </div>
);

export default AboutSection;
